<section class="dashboard container-fluid">
  <h1 class="h2 mb-2">{{ module()?.fd_product ?? 'Módulo' }}</h1>
  <p class="text-body-secondary mb-4">Resumen de registros por recurso.</p>
  <div class="row g-3">
    @for (resource of resources(); track resource.id_universal) {
    <div class="col-12 col-sm-6 col-xl-3">
      <a class="card dashboard-card h-100 text-decoration-none" [routerLink]="'/working/' + resource.route">
        <div class="card-body d-flex align-items-center gap-3">
          <span class="dashboard-icon"><i class="bi {{ resource.icon }}"></i></span>
          <span>
            <span class="d-block fw-semibold">{{ resource.fd_name }}</span>
            <span class="text-body-secondary small">{{ resource.count === null ? 'Cargando...' : resource.count }} registros</span>
          </span>
        </div>
      </a>
    </div>
    }
  </div>
</section>
